import { Box, Flex, ModalFooter } from "@chakra-ui/react";
import { ButtonCustom } from "../../form/controls/form.button";
import { Modal } from "../Modal";
import { useEffect, useState } from "react";
import { DatepickerInput } from "../../form/controls/date-picker.input";

export const JobFilterModal = ({ isOpen, onClose, onSubmit, onClear }) => {
  const [formState, setFormState] = useState({} as any);

  const onInputChange = (event: any) => {
    let { name, value } = event.target;

    if (value === "") value = null;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const { createdDate, completedDate } = formState;

    // validate dates
    if (
      completedDate &&
      createdDate &&
      new Date(completedDate) < new Date(createdDate)
    ) {
      alert(
        "Status updated before date must be greater than status updated after date"
      );
      return;
    }

    // Transform the form state to match the API expected format
    // Extract YYYY-MM-DD format from Date objects
    const formatDate = (date: Date | string | null | undefined): string | null => {
      if (!date) return null;
      const d = new Date(date);
      d.setDate(d.getDate() + 1); // Add one day
      return d.toISOString().split('T')[0];
    };

    const filterData = {
      statusDateRange:
        createdDate || completedDate
          ? {
              from: formatDate(createdDate),
              to: formatDate(completedDate),
            }
          : undefined,
    };

    onSubmit(filterData);
    onClose();
  };

  const handleClear = () => {
    setFormState({});
    onClear({});
    onClose();
  };

  return (
    <Modal
      width="fit-content"
      isOpen={isOpen}
      header="Filter Jobs"
      onClose={onClose}
    >
      <form onSubmit={handleSubmit}>
        <Flex flexDir="column" gap="12px">
          <Flex
            flexDir="row"
            justifyContent="space-between"
            pt="12px"
            gap="12px"
          >
            <DatepickerInput
              title="Created Date"
              name="createdDate"
              initialDate={
                formState?.createdDate
                  ? new Date(formState?.createdDate)
                  : undefined
              }
              onChange={onInputChange}
            />
            <DatepickerInput
              title="Completed Date"
              name="completedDate"
              initialDate={
                formState?.completedDate
                  ? new Date(formState?.completedDate)
                  : null
              }
              onChange={onInputChange}
            />
          </Flex>

          <ModalFooter>
            <Flex gap="12px">
              <ButtonCustom secondary neutral onClick={handleClear}>
                Clear
              </ButtonCustom>
              <ButtonCustom type="submit">Confirm</ButtonCustom>
            </Flex>
          </ModalFooter>
        </Flex>
      </form>
    </Modal>
  );
};
